import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
  inject
} from '@angular/core';
import { FilterModel } from 'ag-grid-enterprise';
import * as _ from 'lodash';
import { CompanyServiceRanking } from 'src/app/classes/models/company-service-ranking';
import { WidgetPanelCounts } from 'src/app/interfaces/widget-panel-counts';
import { CompanyService } from 'src/app/services/company.service';
import { ToastService } from 'src/app/services/toast.service';
import { UtilityService } from 'src/app/services/utility.service';

@Component({
  selector: 'app-spotlight-vendors-widget',
  templateUrl: './spotlight-vendors-widget.component.html',
  styleUrls: ['./spotlight-vendors-widget.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SpotlightVendorsWidgetComponent implements OnInit {
  private _cdr = inject(ChangeDetectorRef);

  constructor(
    private CompanyService: CompanyService,
    private UtilityService: UtilityService,
    private ToastService: ToastService
  ) {}

  @Input() CompanyId!: number;
  companyServiceRankings: CompanyServiceRanking[] = [];

  spotLightVendorCounts: Map<
    string,
    {
      count: number;
      query?: {} | undefined;
      route?: string | undefined;
      FilterModel?: FilterModel;
    }
  > = new Map();

  widgetPanelCounts: WidgetPanelCounts = {
    title: 'Spotlight Vendors',
    noDataMessage: 'No Spotlight Vendors!',
    hasData: false,
    data: this.spotLightVendorCounts
  };

  getCompanySpotlightVendors(CompanyId: number) {
    const clientVendorsRoute = `client/${CompanyId}/vendors/client`;

    const companyServiceRankingQuery = {
      attributes: ['id', 'rank', 'priorityLevel'],
      VendorRanking: {
        $or: [{ VendorId: { $ne: null } }, { ExemptVendorId: { $ne: null } }],
        CompanyVendorExempt: {
          attributes: ['id'],
          viveStatus: { $ne: 'Inactive' }
        },
        CompanyVendorFull: {
          attributes: ['id'],
          viveStatus: { $ne: 'Inactive' }
        }
      },
      order: [['priorityLevel', 'ASC']]
    };

    this.CompanyService.getCompanyServiceRankings(
      this.UtilityService.stringifyObjectsInQueryObject(
        companyServiceRankingQuery
      )
    ).subscribe({
      next: (CompanyServiceRankings: CompanyServiceRanking[]) => {
        this.companyServiceRankings = CompanyServiceRankings;

        this.companyServiceRankings.forEach((serviceRanking, index) => {
          const { rank, VendorRankings } = serviceRanking;

          if (!VendorRankings) {
            throw this.ToastService.addErrorToast(
              'Error',
              'Cannot pull Spotlight Vendors. No VendorRankings found.',
              { returnError: true }
            );
          }

          if (!rank) {
            throw this.ToastService.addErrorToast(
              'Error',
              'Cannot pull Spotlight Vendors. No rank found.',
              { returnError: true }
            );
          }

          const FilterModel: FilterModel = {
            vendorRank: {
              filterType: 'text',
              filter: rank,
              type: 'equals'
            }
          };

          this.spotLightVendorCounts.set(rank, {
            count: VendorRankings.filter((vr) => {
              const { CompanyVendorExempt, CompanyVendorFull } = vr;
              return CompanyVendorExempt !== null || CompanyVendorFull !== null;
            }).length,
            route: clientVendorsRoute,
            FilterModel
          });
        });
        this._cdr.markForCheck();
      }
    });
  }

  ngOnInit(): void {
    this.getCompanySpotlightVendors(this.CompanyId);
  }
}
